export default "__VITE_ASSET__XWdqnAYV__"